/**
 * Brandmark. The pine "L" tile plus the wordmark, in one place, so the shell, the splash and the
 * landing all render the identity the same way (Module 00 component inventory).
 */

export function Brandmark({
  size = 'md',
  markOnly = false,
  className,
}: {
  size?: 'sm' | 'md' | 'lg';
  markOnly?: boolean;
  className?: string;
}) {
  const dims = {
    sm: { box: 'h-6 w-6 rounded-lg text-xs', text: 'text-sm' },
    md: { box: 'h-8 w-8 rounded-lg text-base', text: 'text-lg' },
    lg: { box: 'h-12 w-12 rounded-xl text-2xl', text: 'text-2xl' },
  }[size];

  return (
    <span className={`inline-flex items-center gap-2 ${className ?? ''}`}>
      <span
        className={`flex items-center justify-center bg-primary font-bold text-white ${dims.box}`}
      >
        V
      </span>
      {markOnly ? null : (
        <span className={`font-semibold tracking-tight text-brand ${dims.text}`}>VASP</span>
      )}
    </span>
  );
}
